import * as React from "react";
import { TextCard } from "../frame/index.js";
import { Form, FormActions, Button } from "../form/index.js";
import * as cls from "./ErrataView.module.scss";
import { Config } from "./Config.js";
export { ErrataViewInfo };
/**
 * Выводит отчёт об ошибках.
 *
 * Есть три кнопки:
 * - `Повторить`: Повторная отправка запроса.
 * - `Перезагрузить`: F5. Начинает занятие заново.
 * - `Поддержка`: Создаёт обращение в службу поддержки, содержащее текст ошибки
 *   и URL страницы, на которой она произошла.
 *
 * @summary Вывод отчёта об ошибках как секции учебного продукта.
 * @param {Object} props - Атрибуты элемента.
 * @param {Errata} props.errata - Отчёт об ошибке.
 * @returns {JSX.Element} Элемент JSX.
 * @example
 * import {ServiceError} from "../personal-studio-components/service/index.js";
 * if(request.hasError()) return <ServiceError errata={request.getErrata()}/>;
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function ErrataViewInfo({ errata = {} }) {
  let btnRetry = errata.retry ? (
    <Button
      type="primary"
      icon="play_circle"
      onClick={(event) => {
        event.preventDefault();
        errata.retry();
      }}
    >
      Повторить
    </Button>
  ) : null;
  let btnReload = (
    <Button
      icon="close_circle"
      onClick={(event) => {
        event.preventDefault();
        location.reload();
      }}
    >
      Перезагрузить
    </Button>
  );
  const student_service_url = Config.get("student_service");
  return (
    <Form onSubmit={btnRetry ? btnRetry.onClick : btnReload.onClick}>
      <TextCard type="primary">
        <div
          style={{ whiteSpace: "pre-wrap", wordWrap: "break-word" }}
          className={cls.error_list}
        >
          {errata.errors}
        </div>
      </TextCard>
      {!errata.permanent && (
        <FormActions>
          {errata.error_type === "redirect_info" ? (
            <Button
              type="primary"
              onClick={(event) => {
                event.preventDefault();
                window.open(student_service_url + errata.url, "_blank");
              }}
            >
              Перейти
            </Button>
          ) : (
            <>
              {btnRetry}
              {btnReload}
            </>
          )}
        </FormActions>
      )}
    </Form>
  );
}
